export default __webpack_public_path__ + "static/media/passport.771215d4.jpg";